import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const MakeIcon = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
                fill: "#6D01CB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.28003 7.67002L4.57003 15.06C4.49003 15.21 4.56003 15.4 4.71003 15.47L6.71003 16.48C6.86003 16.56 7.05003 16.5 7.13003 16.34L10.84 8.95002C10.92 8.80002 10.86 8.61002 10.7 8.53002L8.70003 7.52002C8.55003 7.44002 8.36003 7.50002 8.29003 7.66002L8.28003 7.67002Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.86 7.56H17.1C17.27 7.56 17.41 7.7 17.41 7.87V16.14C17.41 16.31 17.27 16.45 17.1 16.45H14.86C14.69 16.45 14.55 16.31 14.55 16.14V7.87C14.55 7.7 14.69 7.56 14.86 7.56Z",
                fill: "white"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M11.41 7.68999L9.82 15.74C9.79 15.91 9.9 16.07 10.06 16.1L12.26 16.54C12.43 16.57 12.59 16.46 12.63 16.3L14.22 8.24999C14.25 8.07999 14.14 7.91999 13.98 7.88999L11.78 7.44999C11.61 7.41999 11.45 7.51999 11.42 7.68999H11.41Z",
                fill: "white"
            })
        ]
    });
};
